<template>
  <div class="schedule">
    <ReportDraftWatermark v-if="report.is_draft" />
    <h2 class="formTitle">Report notes/attachments</h2>
    <v-divider></v-divider>
    <div class="report-section">
      <!--What class would this go in? Assuming this would be on a separate page when printing it out-->
      <div v-for="(attachment, index) in report.user_data.attachments" :key="index">
        <pre>{{ attachment.content }}</pre>
      </div>
      <div v-for="(attachment, index) in report.attachments" :key="index">
        <a :href="attachment.file_service_url" target="_blank" class="noPrint">
          {{ attachment.description }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ReportDraftWatermark from "@/components/ReportDraftWatermark.vue";
export default {
  name: "ReportAttachments",
  components: { ReportDraftWatermark },
  props: {
    report: Object
  }
}
</script>

<style scoped>
.schedule { position: relative }
pre {
  white-space: pre-wrap;       /* Since CSS 2.1 */
  white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
  white-space: -pre-wrap;      /* Opera 4-6 */
  white-space: -o-pre-wrap;    /* Opera 7 */
  word-wrap: break-word;       /* Internet Explorer 5.5+ */
}
</style>
